import { useEffect, useState } from "react";
import { MdClose } from "react-icons/md";
import { toast } from "react-toastify";

const UpdateBlogModal = ({ blogId, toggleModal, showModal, onBlogUpdated }) => {
  const [title, setTitle] = useState("");
  const [image, setImage] = useState(null);
  const [link, setLink] = useState("");

  useEffect(() => {
    const fetchBlog = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/blogs/single-blog/${blogId}`
        );
        if (!response.ok) throw new Error("Failed to fetch blog.");
        const data = await response.json();

        setTitle(data.allBlogs[0].title);
        setLink(data.allBlogs[0].link);
      } catch (error) {
        console.error("Fetch error:", error);
        toast.error("Error fetching blog.");
      }
    };
    fetchBlog();
  }, [blogId]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("title", title);
    formData.append("link", link);
    if (image) {
      formData.append("blog_image", image);
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/blogs/updateblog/${blogId}`,
        {
          method: "PUT",
          body: formData,
        }
      );

      if (!response.ok) throw new Error("Network response was not ok");
      await response.json();
      toast.success("Blog updated successfully!");
      resetFormFields();
      toggleModal();
      onBlogUpdated();
    } catch (error) {
      console.error("Error:", error);
      toast.error(`Failed to update blog: ${error.message}`);
    }
  };

  const resetFormFields = () => {
    setTitle("");
    setImage(null);
    setLink("");
  };

  const closingModal = () => {
    resetFormFields();
    toggleModal();
  };

  return (
    <>
      <div
        className="fixed inset-0 z-40 bg-navy-900 opacity-50"
        onClick={toggleModal}
      ></div>

      <div
        className={`fixed right-0 top-0 h-screen w-2/3 transform bg-white transition-transform ${
          showModal ? "translate-x-0" : "translate-x-full"
        } z-50 shadow-lg`}
      >
        <div className="flex h-full flex-col bg-navy-700">
          <div className="flex items-center justify-between bg-gray-500 p-3 shadow-md">
            <div className="flex-col">
              <h1 className="text-xl">Update Blog</h1>
              <h1 className="text-lg">Update the blog from here</h1>
            </div>
            <MdClose
              className="cursor-pointer rounded-full bg-navy-900 p-1 text-3xl text-white"
              onClick={closingModal}
            />
          </div>

          <form
            onSubmit={handleSubmit}
            encType="multipart/form-data"
            className="no-scrollbar h-full flex-col items-center overflow-y-scroll p-5 "
          >
            <div className="mb-5 flex w-full items-center justify-between">
              <h1 className="w-2/5 text-lg text-white">Image</h1>
              <input
                className="w-3/5 rounded-md p-2"
                type="file"
                accept="image/*"
                onChange={(e) => setImage(e.target.files[0])}
              />
            </div>
            <div className="mb-5 flex w-full items-center justify-between">
              <h1 className="w-2/5 text-lg text-white">Title</h1>
              <input
                className="w-3/5 rounded-md p-2"
                type="text"
                placeholder="Blog Title"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
            </div>

            <div className="mb-5 flex w-full items-center justify-between">
              <h1 className="w-2/5 text-lg text-white">News / Blog Link</h1>
              <input
                className="w-3/5 rounded-md p-2"
                type="text"
                placeholder="Blog Link"
                value={link}
                onChange={(e) => setLink(e.target.value)}
              />
            </div>

            <div className="mt-10 flex flex-wrap justify-center gap-2">
              <button
                type="submit"
                className="w-1/2 rounded-md bg-primary p-2 text-lg text-white"
              >
                Update Blog
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default UpdateBlogModal;
